<script setup lang="ts">
  import { ColumnDefinition } from '@/shared/Table/models/ColumnDefinition'
  import { HierarchicExecutionViewModel } from '../models/HierarchicExecutionViewModel'

  import ExecutionHistory from '../ExecutionHistory.vue'
  import { h, ref } from 'vue'
  import { Check } from 'lucide-vue-next'
  import Button from '@/components/ui/button/Button.vue'
  import { ExecutionPhaseType } from '@/shared/Executions/models/ExecutionPhaseType'
  import { ExecutionStatusType } from '@/shared/Executions/models/ExecutionStatusType'

  interface IExecutionSelectionTableProps {
    executionTypeFilter?: Array<ExecutionPhaseType>
  }

  defineProps<IExecutionSelectionTableProps>()

  const emit = defineEmits<{
    'execution-selected': [execution: HierarchicExecutionViewModel]
  }>()

  const handleAnalysisExecutionSelected = (record: HierarchicExecutionViewModel) => {
    emit('execution-selected', record)
  }

  const customActionColumn = ref<ColumnDefinition<HierarchicExecutionViewModel>>(
    new ColumnDefinition(
      'select',
      'select',
      'Select',
      (opt: { record: HierarchicExecutionViewModel }) =>
        h(
          'a-tooltip',
          {
            title: String(
              opt.record?.status !== ExecutionStatusType.Succeeded
                ? 'Only successful Executions selectable'
                : 'Select Execution'
            )
          },
          h(
            Button as any,
            {
              disabled: opt.record?.status !== ExecutionStatusType.Succeeded,
              size: 'icon',
              variant: 'secondary',
              onClick: () => handleAnalysisExecutionSelected(opt.record)
            },
            h(Check, { class: 'size-5' })
          )
        )
    )
  )
</script>

<template>
  <ExecutionHistory
    @execution-selected="handleAnalysisExecutionSelected"
    :execution-selection-action-enabled="false"
    :custom-action-column="customActionColumn"
    :execution-phase-type-filter="executionTypeFilter"
    title="Select an an Analysis for calculations"
    description="Select an an Analysis for calculations"
  />
</template>
